import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import PhoneInput from "@Shared/components/inputs/phone-input.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { mapState } from "vuex";
export default defineComponent({
  name: "MfaContainer",
  components: {
    PhoneInput,
    SimpleButton,
    MaterialInput
  },
  props: {
    redirectPath: {
      type: String,
      default: "/"
    },
    sendingMfaCode: {
      type: Boolean,
      default: false
    },
    mfaCodeDelivered: {
      type: Boolean,
      default: true
    },
    validateMfaCode: {
      type: Boolean,
      default: false
    },
    isMfaRequiredAndNotEnabled: {
      type: Boolean,
      default: false
    },
    codeDestination: {
      type: String,
      default: ""
    },
    mfaPreferences: {
      type: Object,
      default() {
        return {};
      }
    },
    mfaEmail: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      loadingStatus: true,
      phoneNumber: null,
      mfaCode: "",
      isTrustedDevice: false,
      selectedMethodMfa: "sms",
      enableSendCodeButton: false
    };
  },
  computed: _objectSpread({}, mapState("AccountStore", ["token"])),
  watch: {
    selectedMethodMfa() {
      if (this.selectedMethodMfa === "email") {
        this.phoneNumber = null;
      }
      this.updateEnableSendCodeButton();
    }
  },
  beforeMount() {},
  methods: {
    snoozeMfaSetup() {
      this.$emit("snoozeMfaSetup");
    },
    reSendCode() {
      this.$emit("reSendCode");
    },
    updateUserMfa() {
      const mfaValue = this.selectedMethodMfa === "sms" ? this.phoneNumber : this.mfaEmail;
      this.$emit("enableMfa", {
        mfaValue,
        method: this.selectedMethodMfa
      });
    },
    validateMfaAndSignIn() {
      this.$emit("validateMfaAndSignIn", {
        mfaCode: this.mfaCode,
        isTrustedDevice: this.isTrustedDevice
      });
    },
    updateEnableSendCodeButton(body) {
      if (this.selectedMethodMfa === "email") {
        this.enableSendCodeButton = true;
        return;
      }
      if (body) {
        this.phoneNumber = body.phoneNumber;
        this.enableSendCodeButton = !!body.isValueValid;
      } else {
        this.enableSendCodeButton = false;
      }
    }
  }
});